import React from 'react';
import PropTypes from 'prop-types';
import { MainContainer } from './LayoutStyles';

function Main({ children }) {
  return <MainContainer>{children}</MainContainer>;
}

Main.propTypes = {
  children: PropTypes.object
};

export default Main;
